import { render, staticRenderFns } from "./FilesCard.vue?vue&type=template&id=4bbb0d8c&scoped=true"
import script from "./FilesCard.vue?vue&type=script&lang=js"
export * from "./FilesCard.vue?vue&type=script&lang=js"
import style0 from "./FilesCard.vue?vue&type=style&index=0&id=4bbb0d8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbb0d8c",
  null
  
)

export default component.exports